<template>
		<v-layout fill-height column>
			<div v-for="(item, itemIndex) in items" :key="itemIndex">
				<template v-if="item.type == 'banner' && itemIndex == 0">
					<v-container :class="outerContainer">

						<v-flex class="mt-15">
                            <v-img :width="$vuetify.breakpoint.smAndUp ? '500px' : '250px'"
                                contain :src="{ backgroundImage: `url(${item.image})` }"
                            >
                            </v-img>
                            <div class="space-mono text-left pt-10" :class="$vuetify.breakpoint.smAndUp ? 'h3' : 'h4'">
                                <span class="bpn-highlighted-string"
                                    @focusout="editableData('banner', { element: 'heading' })" :contenteditable="editableContent"
                                    v-html="item.heading"
                                >
                                </span>
                            </div>
                            <div class="h5 poppins text-left"
                                @focusout="editableData('banner', { element: 'subtitle' })" :contenteditable="editableContent"
                                v-html="item.subtitle"
                            >
                            </div>
						</v-flex>

						<RowControls v-if="pageType == 'Canvas'" :rowIndex="itemIndex" />
					</v-container>
				</template>

				<template v-if="item.type == 'grids'">
					<Grid2 :item="item"
						:index="itemIndex"
						:styles="{
							text: 'body poppins',
							image: {
								contain: true,
								wrapper: '',
								class: '',
								height: 'auto',
								width: 'auto',
								maxWidth: '100%',
								maxHeight: '',
								custom: {
									margin: '0 auto'
								}
							},
							heading1: {
								wrapper: 'justify-center',
								classMobile: 'h5 space-mono bpn-highlighted-string mt-10',
								classLarge: 'h4 space-mono bpn-highlighted-string mt-10',
								after: '',
								guideWrapper: '',
								guideClass: 'mt-10 ml-5'
							},
							heading2: {
								wrapper: 'justify-center',
								classMobile: 'h5 space-mono bpn-highlighted-string mt-10',
								classLarge: 'h4 space-mono bpn-highlighted-string mt-10',
								after: '',
								guideWrapper: '',
								guideClass: 'mt-10 ml-5'
							},
							textcard: {
								outlined: false,
								elevation: 0,
								card: 'bpn-card text-center pa-5',
								text: 'h5 space-mono bpn-highlighted-string-white mb-5',
								subtitle: 'body poppins text-left mt-5'
							},
							imagecard: {
								doubleCard: false,
								elevation: 0,
								outlined: false,
								card: 'pa-5',
								imagePosition: 'top',
								image: {
									height: '',
									width: '250px'
								},
								text: 'h5 poppins font-weight-bold text-left my-3',
								subtitle: 'text-left body poppins grey-text'
							},
							dialog: {
								elevation: '',
								cardClass: 'py-5 px-5 my-5',
								cardColor: '#40D0FE',
								innerCard: 'business-process-inner-card  text-center px-5 py-5',
								dialogTitle: 'h5 space-mono bpn-highlighted-string-white mb-5',
								textWrapper: 'body poppins text-left responsive-text',
								dialogName: 'body poppins font-weight-bold text-left mr-3 responsive-text',
								custom: {
									text: '',
									textClass: 'mt-5'
								}
							}
						}"
					/>
				</template>
			</div>

			<ImageUploader />
		</v-layout>
</template>

<script>
import RowControls from "@/components/RowControls.vue"
import ImageUploader from "@/components/ImageUploadModal.vue"
import { Grid2 } from "@/imports/elements.js"
import Vue from "vue"
import { highlights } from "@/mixins/highlights"

export default {
    props: ["items"],
    components: {
        RowControls, ImageUploader, Grid2
    },
    computed: {
        bannerTextSize () {
            return this.$vuetify.breakpoint.smAndDown ? "h4" : "h3"
        }
    },
    methods: {

    }
}
</script>

<style scoped>

.grey-text {
  color: #6c757d;
}
</style>
